import { isProduction, loggerS3Bucket, loggerS3Path } from 'src/config';
import { metrics } from '@seek/metrics-js';
import impressionTrackingLogger from 'src/modules/impression-tracking-logger';

const clientLogger = {
  /* eslint-disable no-console */
  trace() {},
  debug() {},
  info() {},
  warn() {
    if (!isProduction) {
      console.warn(...arguments);
    }
    metrics.count('clientwarnlogged', []);
    impressionTrackingLogger.warn(...arguments);
  },
  error() {
    if (!isProduction) {
      console.error(...arguments);
    }
    // Metric to get a scale on how many errors would be logged client-side.
    // Intention is if manageable, we call an API to log these server side.
    metrics.count('clienterrorlogged', []);
    impressionTrackingLogger.error(...arguments);
  }
  /* eslint-enable no-console*/
};

function createLogger(logName, s3Options) {
  if (ENV.CLIENT) {
    return clientLogger;
  }

  const { default: Logger, StreamType } = require('@seek/logger-js');

  const logger = new Logger({
    name: logName,
    streamType: StreamType.FILE,
    logPath: './logs',
    ...(s3Options ? { s3Options } : {})
  });

  return logger;
}

const s3Options = {
  bucket: loggerS3Bucket,
  path: loggerS3Path,
  prefix: process.env.INSTANCE_ID || 'dev'
};

const logger = createLogger('chalice-applogs');
const s3Logger = createLogger('chalice_full-logs', s3Options);

function middleware(req, res, next) {
  const oldEnd = res.end;
  res.end = (...args) => {
    if (res.statusCode >= 300) {
      logger.info({ req, res }, `Request ${req.path}`);
    }

    s3Logger.info({ req, res }, `Request ${req.path}`);

    oldEnd.apply(res, args);
  };

  next();
}

export { logger, s3Logger, middleware };
